(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["everbright-review-strip"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('everbright-review-strip')) {
  customElements.define('everbright-review-strip', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-review-viewport]');
      this.track = this.querySelector('[data-review-track]');
      this.original = this.querySelector('[data-review-original]');
      this.button = this.querySelector('[data-review-toggle]');
      if (!this.viewport || !this.track || !this.original || !this.button) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.motion.addEventListener('change', () => this.schedule(), { signal });
      this.button.addEventListener('click', () => {
        this.setPaused(this.dataset.paused !== 'true');
      }, { signal });
      this.viewport.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse') this.setPaused(true);
      }, { signal });
      this.addEventListener('focusin', (event) => {
        if (!event.target.closest('[data-review-toggle]')) this.setPaused(true);
      }, { signal });
      this.setPaused(this.dataset.paused === 'true');
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.schedule());
        this.resizeObserver.observe(this.viewport);
        this.resizeObserver.observe(this.original);
      } else {
        window.addEventListener('resize', () => this.schedule(), { signal });
      }
      if ('IntersectionObserver' in window) {
        this.viewObserver = new IntersectionObserver((entries) => {
          this.dataset.inView = String(entries.some((entry) => entry.isIntersecting));
        });
        this.viewObserver.observe(this);
      }
      this.schedule();
    }
    schedule() {
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        if (this.isConnected) this.configure();
      });
    }
    configure() {
      this.track.querySelectorAll('[data-review-copy]').forEach((copy) => copy.remove());
      const cards = this.original.querySelectorAll('[data-review-card]').length;
      if (this.dataset.autoplay !== 'true' || this.motion.matches || cards < 2) {
        this.dataset.animated = 'false';
        this.button.hidden = true;
        return;
      }
      const travel = this.original.getBoundingClientRect().width;
      const width = this.viewport.getBoundingClientRect().width;
      if (!travel || !width) return;
      const speed = Math.max(10, Number(this.dataset.speed) || 30);
      this.style.setProperty('--eb-review-travel', travel + 'px');
      this.style.setProperty('--eb-review-duration', (travel / speed) + 's');
      const copies = Math.max(1, Math.ceil(width / travel));
      for (let index = 0; index < copies; index++) {
        const copy = this.original.cloneNode(true);
        copy.removeAttribute('data-review-original');
        copy.setAttribute('data-review-copy', '');
        copy.setAttribute('aria-hidden', 'true');
        copy.setAttribute('inert', '');
        copy.classList.add('eb-review-strip__copy');
        copy.querySelectorAll('[data-shopify-editor-block]').forEach((block) => {
          block.removeAttribute('data-shopify-editor-block');
        });
        this.track.append(copy);
      }
      this.dataset.animated = 'true';
      this.button.hidden = false;
    }
    setPaused(paused) {
      this.dataset.paused = String(paused);
      this.button?.setAttribute('aria-pressed', String(paused));
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.viewObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('everbright-gold-sweep')) {
  customElements.define('everbright-gold-sweep', class extends HTMLElement {
    connectedCallback() {
      if (this.getAttribute('data-sweep-state') === 'visible') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;
      if (this.sweepObserver) this.sweepObserver.disconnect();
      this.setAttribute('data-sweep-state', 'pending');
      this.sweepObserver = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.6)) return;
        this.setAttribute('data-sweep-state', 'visible');
        this.sweepObserver?.disconnect();
        this.sweepObserver = null;
      }, { threshold: 0.6, rootMargin: '0px 0px -48px 0px' });
      this.sweepObserver.observe(this);
    }
    disconnectedCallback() {
      if (this.sweepObserver) this.sweepObserver.disconnect();
      this.sweepObserver = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
